import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import SearchResults from './SearchResults';

const styles = (theme) => ({
  root: {
    borderRadius: 4,
    background: 'darkslategrey',
    width: 600,
    padding: '0px 10px'
  },
  input: {
    color: theme.palette.common.white,
    border: '0 none',
    background: 'darkslategrey',
    padding: '10px 10px',
    '&::placeholder': {
      color: theme.palette.common.white,
      opacity: 0.7
    }
  },
  icon: {
    color: theme.palette.common.white,
    margin: '1px 5px 0px 0px'
  }
});

class Searchbar extends Component {

  constructor(props) {
    super(props);
    this.bar = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleShortcuts);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleShortcuts);
  }

  handleShortcuts = (evt) => {
    if (evt.ctrlKey && evt.key === 'f') {
      this.bar.current.focus();
    }

    if (evt.key === 'Escape') {
      this.props.onClose();
    }
  };

  render() {
    const {
      classes,
      query,
      results,
      selected,
      onChange,
      onSelect,
      onKeyDown
    } = this.props;

    const res = !!results ? results : [];
    return (
      <div className={classes.root}>
        <TextField
          variant="standard"
          value={query}
          id="searchbar"
          inputRef={this.bar}
          placeholder="Search Galileo..."
          autoComplete="off"
          onChange={onChange}
          onKeyDown={onKeyDown}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: classes.root,
              input: classes.input
            },
            startAdornment: (
              <InputAdornment position="start">
                <Search className={classes.icon} />
              </InputAdornment>
            )
          }} />
        <SearchResults
          results={res}
          selected={selected}
          onSelect={onSelect}
        />
      </div>
    );
  }
}

Searchbar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Searchbar);
